var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1H9V2H3V1ZM2 3V2H3V3H2ZM2 9V3H1V9H2ZM3 10V9H2V10H3ZM9 10V11H3V10H9ZM10 9V10H9V9H10ZM10 3H11V9H10V3ZM10 3V2H9V3H10ZM5.5 2.5H6.5V3.5H8V4.5H6.5H5.5H5V5.5H7H8V6.5V7.5V8.5H7H6.5V9.5H5.5V8.5H4V7.5H5.5H6.5H7V6.5H5H4V5.5V4.5V3.5H5H5.5V2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarS);
export default __webpack_public_path__ + "static/media/dollar-s.5cac26ded4f051241977f430ba97d630.svg";
export { ForwardRef as ReactComponent };